export default {
  width: '95%'
};
